// Decoupled bridge between the axios interceptor (http/index.js) and the MobX
// store (registered in main.jsx). Avoids a circular import: http <-> store.
let onSessionExpired = null;

export const setSessionExpiredHandler = (fn) => {
    onSessionExpired = fn;
};

export const notifySessionExpired = () => {
    if (typeof onSessionExpired === 'function') onSessionExpired();
};
